import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1919.98871,168.954824 L1919.98871,394.950118 L1087.27341,394.950118 L611.113412,1646.33835 L398.332235,1641.59482 L203.960471,1053.05835 L-0.0112941176,1053.05835 L-0.0112941176,827.176 L285.504,827.176 L392.798118,904.766588 L513.080471,1268.88894 L903.856941,241.801882 L1009.45694,168.954824 L1919.98871,168.954824 Z M1265.72047,788.990588 L1505.89671,1029.16682 L1746.05929,789.047059 L1905.75812,948.632941 L1665.55971,1188.82982 L1905.75812,1429.02824 L1746.05929,1588.61412 L1505.89571,1348.49382 L1265.72047,1588.67059 L1106.02165,1428.97176 L1346.20471,1188.82982 L1106.02165,948.689412 L1265.72047,788.990588 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconEquationSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconEquationSolid, _Component);

  var _super = _createSuper(IconEquationSolid);

  function IconEquationSolid() {
    _classCallCheck(this, IconEquationSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconEquationSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconEquation",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconEquationSolid.displayName = "IconEquationSolid";
  return IconEquationSolid;
}(Component);

IconEquationSolid.glyphName = 'equation';
IconEquationSolid.variant = 'Solid';
IconEquationSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconEquationSolid;
export { IconEquationSolid };